"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
exports.__esModule = true;
var angular = require("angular");
var envelope_chart_chart_1 = require("./envelope-chart.chart");
var envelope_chart_logic_1 = require("./envelope-chart.logic");
var basic_chart_component_1 = require("../basic-component/basic-chart.component");
var metalog_chart_maker_1 = require("../metalog/app/js/logic/metalog-chart-maker");
var MetalogChartMaker = metalog_chart_maker_1["default"].MetalogChartMaker;
var metalog_1 = require("../metalog/app/js/logic/metalog");
var EnvelopeChartComponent = /** @class */ (function (_super) {
    __extends(EnvelopeChartComponent, _super);
    function EnvelopeChartComponent($scope, $timeout) {
        var _this = 
        // This constructor is necessary for inject scope and timeout.
        _super.call(this, $scope, $timeout, 'EnvelopeChart') || this;
        var ctrl = _this;
        $scope.$on('export:csv', function (event, args, callback) {
            var csv = envelope_chart_logic_1.EnvelopeChartLogic.downloadCsv(angular.copy(ctrl.selectedGraph), args.filename, args.csvFormat, args.skipSave || false);
            if (callback) {
                callback(csv);
            }
        });
        $scope.$on('command:ENVELOPE_CHART', function (event, args) {
            ctrl.actionMenuItem = args.actionMenuItem;
            var config = args.config.data;
            var inputData = config.tornados;
            var shadowInputData = config.shadowTornados ? config.shadowTornados : undefined;
            var shadowNodeName = config.shadowNodeName ? config.shadowNodeName : undefined;
            var nodeName = config.nodeName;
            var failureBranch = undefined;
            if (config.failureBranchExist) {
                var failureBranchStages = config.failureBranchStages;
                failureBranch = {
                    "probability": metalog_1.FailureBranch.sumProbability(failureBranchStages),
                    "subtractionValue": metalog_1.FailureBranch.sumSubtractionValue(failureBranchStages),
                    "arrayOfFailureBranchPoints": metalog_1.FailureBranch.arrayFailureBranchPoints(failureBranchStages)
                };
            }
            var selectedShadowInputData = undefined;
            var tenFiftyNinety = [];
            var shadowTenFiftyNinety = [];
            inputData.forEach(function (input) {
                var allFeasiblePanels = new metalog_1.MetaLogPanel(input.MetaLogOutputs.Panel).allFeasiblePanels();
                var selectedTerm = metalog_1.MetaLogPanel.getSelectedTerm(allFeasiblePanels);
                var selectedTermShadow = null;
                if (config.shadowTornados) {
                    selectedShadowInputData = shadowInputData.find(function (shadowInput) { return shadowInput.Key == input.Key; });
                    var allFeasiblePanelsShadow = new metalog_1.MetaLogPanel(selectedShadowInputData.MetaLogOutputs.Panel).allFeasiblePanels();
                    selectedTermShadow = allFeasiblePanelsShadow[allFeasiblePanelsShadow.length - 1].NumberOfTerms;
                }
                var chartMaker = new MetalogChartMaker(input, selectedShadowInputData, shadowNodeName, nodeName, config.colors, undefined, undefined, undefined);
                chartMaker.initialize(selectedTerm, failureBranch, selectedTermShadow);
                var fittedPoints = chartMaker.fittedPointsOnCDF(chartMaker.inputData);
                var summary = envelope_chart_logic_1.EnvelopeChartLogic.calculateTenFiftyNinety(fittedPoints);
                tenFiftyNinety.push(summary);
                if (config.shadowTornados) {
                    var shadowFittedPoints = chartMaker.fittedPointsOnCDF(chartMaker.shadowInputData);
                    var shadowSummary = envelope_chart_logic_1.EnvelopeChartLogic.calculateTenFiftyNinety(shadowFittedPoints);
                    shadowTenFiftyNinety.push(shadowSummary);
                }
            });
            if (tenFiftyNinety.length == config.years.length) {
                var envelopeChartData_1 = [];
                var envelopeShadowChartData_1 = [];
                config.years.forEach(function (year, i) {
                    envelopeChartData_1.push([year, tenFiftyNinety[i]['Low'], tenFiftyNinety[i]['Base'], tenFiftyNinety[i]['High']]);
                    if (config.shadowTornados) {
                        envelopeShadowChartData_1.push([year, shadowTenFiftyNinety[i]['Low'], shadowTenFiftyNinety[i]['Base'], shadowTenFiftyNinety[i]['High']]);
                    }
                });
                envelopeChartData_1 = envelope_chart_logic_1.EnvelopeChartLogic.addMissingRow(envelopeChartData_1);
                envelopeShadowChartData_1 = config.shadowTornados ?
                    envelope_chart_logic_1.EnvelopeChartLogic.addMissingRow(envelopeShadowChartData_1) :
                    envelopeShadowChartData_1;
                var envelopeArgs = angular.copy(args);
                envelopeArgs['config']['data']['data'] = [{
                        'mainRows': envelopeChartData_1,
                        'siblingRows': envelopeShadowChartData_1,
                        'nodeName': args.nodeName,
                        'siblingNodeName': shadowNodeName
                    }];
                ctrl.initComponent(event, envelopeArgs);
            }
        });
        return _this;
    }
    EnvelopeChartComponent.prototype.getChartOptions = function (graph, options) {
        return envelope_chart_chart_1.getChartOptions(graph, options);
    };
    EnvelopeChartComponent = __decorate([
        basic_chart_component_1.Component({
            bindings: {
                menu: '='
            },
            template: require("./envelope-chart.component.html")
        }),
        __metadata("design:paramtypes", [Object, Object])
    ], EnvelopeChartComponent);
    return EnvelopeChartComponent;
}(basic_chart_component_1.BasicChartComponent));
exports.EnvelopeChartComponent = EnvelopeChartComponent;
angular.module('smartorg.r6.acts.envelopeChart', []).filter('textOrNumber', ['$filter', function ($filter) {
        return function (input, fractionSize) {
            if (isNaN(input) || (fractionSize == "Default")) {
                return input;
            }
            else {
                return $filter('number')(input, fractionSize);
            }
        };
    }]).component('envelopeChart', EnvelopeChartComponent);
module.exports = 'smartorg.r6.acts.envelopeChart';
//# sourceMappingURL=envelope-chart.component.js.map


// WEBPACK FOOTER //
// ./app/widgets/action/envelope-chart/envelope-chart.component.js